import flatten from 'lodash/flatten';
import toArray from 'lodash/toArray';

require('./bootstrap');

//  Settings

var setting = {
    mediaQuery: {
        small: 640,
        medium: 768,
        large: 960,
        huge: 1140
    },
    sending: '<div class="sending"><span></span></div>',
    thankYou: '<p>Thank you, your message has been sent</p>'
};


//  Variables

var $core = {},
    $site = {},
    site = {};


//
//  Begin jQuery
//

$(function(){

    //  Variables
    $core = {
        win: $(window),
        doc: $(document),
        body: $('body')
    };

    $site = {
        nav: {
            root: $('.top'),
            menu: $('.top .primary'),
            toggle: $('.top span')
        },
        map: $('.google-map'),
        treatments: $('#treatments-wrapper')
    };

    site = {
        resize: false,
        size: {
            x: $core.win.width(),
            y: $core.win.height()
        },
        map: null,
        scroll: 0,
        transitions: $.support.transition,
        touch: detectTouch()
    };


    //
    //  Functions
    //

    var afterResize = function(){

        site.size.x = $core.win.width();

        $site.nav.menu.removeAttr('style');

        activateSlider();

    };

    var activateSlider = function(){

        if( site.size.x >= setting.mediaQuery.small ){

            $('.slider').slider();

        } else{

            $('.slider').trigger('unset');

        }

    };

    var activateMap = function(){

        var mapLatLang = new google.maps.LatLng(53.99980, -1.50081);

        var mapOptions = {
            panControl: false,
            mapTypeControl: false,
            center: mapLatLang,
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false
        };

        site.map = new google.maps.Map($site.map[0], mapOptions);

        var marker = new google.maps.Marker({
            position: mapLatLang,
            animation: google.maps.Animation.DROP,
            map: site.map,
            title: 'Divine Automotive',
            icon: '/img/template/pin.png',
        });

    };

    var numberWithCommas = function(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    //
    //  Events
    //

    $site.nav.toggle.on('click', function(){

        $site.nav.menu.toggle();

    });

    $('.range-track').each(function(){

        var $slider = $(this);

        $slider = {
            root:  $slider,
            grip:  $slider.find('.range-grip'),
        };

        var grip = {
            x: 0,
            start: 0,
            end: 0,
            max: 0
        };

        var value = {
            min: $slider.root.data('min'),
            max: $slider.root.data('max'),
            for: $slider.root.data('for'),
            start: $slider.root.data('start'),
            incriment: $slider.root.data('incriment'),
            unit: {
                before: $slider.root.data('unitbefore'),
                after: $slider.root.data('unitafter')
            }
        };

        var mouse = {
            x:      0
        };

        var setX = function(x){

            // NewValue = (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin
            x = ( x * 100 ) / grip.max;

            if( x < 0 )
                x = 0;

            if( x > 100 )
                x = 100;

            return x;

        };

        var setText = function(x){

            var text = ( ( x * ( value.max - value.min ) ) / 100 ) + value.min;

            if( value.incriment )
                text = Math.round( text / value.incriment ) * value.incriment;

            text = numberWithCommas( Math.round(text) ) + ( text == value.max ? '+' : '' );

            if( value.unit.before )
                text = value.unit.before + text;

            if( value.unit.after )
                text = value.unit.after + text;

            return text;

        };

        var setGrip = function(x){

            $slider.grip.css({
                left:   x + '%'
            }).text( setText(x) );

            $slider.root
                .siblings('input[name="' + value.for + '"]')
                .val(setText(x));

        };

        $slider.grip.on('mousedown touchstart', function(e){

            mouse.x = site.touch ? e.originalEvent.touches[0].pageX : e.pageX;
            grip.start = $slider.grip.position().left;
            grip.max = $slider.root.children('div').width();

            $core.win.on('mousemove.range-grip mouseup.range-grip touchmove.range-grip touchend.range-grip', function(e){

                if( e.type == 'mousemove' || e.type == 'touchmove' ){

                    var x = setX( ( site.touch ? e.originalEvent.targetTouches[0].pageX : e.pageX ) - mouse.x + grip.start );

                    setGrip(x);

                }else if( e.type == 'mouseup' || e.type == 'touchend' ){

                    $core.win.off('mousemove.range-grip mouseup.range-grip touchmove.range-grip touchend.range-grip');

                }

                e.preventDefault();

            });

        });

        setGrip( value.start ? value.start : 50 );

    });

    let processResponse = function ($form, response, isError = false) {

        $form.message = $('<p />', {
           text: 'Thank you, your message has been sent'
        }).removeClass('error');

        if (isError) {
            let message = 'Please ensure all fields are completed.';

            if (response.response && response.response.data.errors) {
                message = flatten(toArray(response.response.data.errors)).join('<br>');
            }

            $form.message
                .html(message)
                .addClass('error');
        }

        $form.message
            .appendTo($form.overlay)
            .css({
                scale: .5,
                top: '50%',
                left: '50%',
                perspective: 600,
                rotateX: 90,
                opacity: 0,
                margin: (0 - Math.round($form.message.outerHeight() / 2)) + 'px 0 0 ' + (0 - Math.round($form.message.outerWidth() / 2)) + 'px'
            })
            .transition({
                scale: 1,
                rotateX: 0,
                opacity: 1
            }, 400, 'easeOutCubic', function () {

                $form.overlay
                    .children('span').addClass('fucer')
                    .transition({
                        opacity: 0
                    }, 200, 'smoothFade', function () {

                        $(this).remove();

                    });

                $form.message
                    .delay(2000)
                    .transition({
                        scale: .5,
                        rotateX: -90,
                        opacity: 0
                    }, 400, 'easeInCubic', function () {

                        $form.message
                            .remove();

                        $form.overlay
                            .transition({
                                opacity: 0
                            }, 400, 'smoothFade', function () {

                                $form.overlay
                                    .remove();

                            });

                    });

                $form.fieldset
                    .delay(1800)
                    .transition({
                        opacity: 1,
                        scale: 1
                    }, 400, 'easeInOutCubic');

            });
    }

//  Form submission
    $('form').each(function(){

        //  Get all the moving parts
        var $form = $(this);

        $form = {
            root: $form,
            fieldset: $form.find('fieldset'),
            overlay: $(setting.sending),
            message: $(setting.thankYou),
        };

        $form.root.on('submit', function(e){

            e.preventDefault();

            //  Form overlay
            $form.overlay
                .appendTo( $form.root )
                .css({
                    opacity: 0
                })
                .transition({
                    opacity: 1
                }, 400, 'smoothFade');

            $form.fieldset
                .transition({
                    opacity: .4,
                    scale: .9
                }, 400, 'easeInOutCubic');

            axios({
                method: $form.root.attr('method'),
                url: $form.root.attr('action'),
                data: $form.root.serialize()
            })
                .then(response => processResponse($form, response))
                .catch(error => processResponse($form, error, true));
        });

    });


    //
    //  Indirect events
    //

    $core.win.on({

        resize: function(){

            clearTimeout(site.resize);

            site.resize = setTimeout(function(){

                afterResize();

            }, 200);

        },
        scroll: function(){

            site.scroll = document.documentElement.scrollTop;
            site.scroll = site.scroll === 0 ? document.body.scrollTop : site.scroll;

        }

    });


    //
    //  Ready? Go!
    //

    $('#part-x-bool').on('change', function(){

        $('#part-x').css({
            height: $(this).val() == 'yes' ? 'auto' : 0
        });

    });

    $('[data-img]').loadImages();

    $('.inline-gallery').inlineGallery();

    $('.car.has-gallery').popupGallery();

    $('[data-popup]').popupContent();

    if( $site.map.length )
        activateMap();

    if( site.size.x >= setting.mediaQuery.medium )
        activateSlider();

    $core.body.on('click', 'a:external', function(e){

        if( e.which != 2 ){

            window.open( $(this).attr('href') );

            e.preventDefault();

        }

    });

    $('a[href^="#"]').scrollTo();

    $('[data-colour]').each(function(){

        var $this = $(this);

        $this.css({
            borderColor: $this.data('colour')
        });

    });

    $('select:visible').simpleSelect();

    //  The google images style plugin for the treatments
    $site.treatments.openAfterRow({
        beforeInsert: function($template, $item, $link, id){

            //  Get some variables and objects together
            var $arrow = $template.find('.arrow'),
                content = $item.find('.content').html();

            //  Place the content
            $template
                .find('.row')
                .html(content);

            //  Put the arrow in the correct position
            $arrow
                .css({
                    left: $item.position().left + ( $item.width() / 2 ) - ( $arrow.width() / 2 )
                });

            if( site.size.x > setting.mediaQuery.medium ){

                var $details = $template.find('.details'),
                    detailsTop = Math.round( ( $template.find('.row').height() - $details.height() ) / 2 );

                //  Apply it
                $details
                    .css({
                        top: detailsTop
                    });

            }

            //  Animate the old link away, and bring in the new one
            $link.inAndOut({
                middle: function(){

                    $link
                        .text('Close')

                }
            });

        },
        onClose: function($item){

            //  Get the link
            var $link = $item.find('.button-extra-small');

            //  Put it back how it was before
            $link.inAndOut({
                middle: function(){

                    $link
                        .text('Find out more');

                }
            });

        }
    });

});


//
//  Plugins
//

(function($){

    var getSpeed = function(why){

        var distance = Math.abs( why - site.scroll );

        return distance / 5;

    };

    $.scrollTo = function(settings){

        var defaults = {
            speed: 'auto',
            easing: 'easeInOutExpo',
            why: 0,
            before: function(){},
            after: function(){}
        };

        var option = $.extend({}, defaults, settings);

        option.speed = option.speed == 'auto' ? getSpeed(option.why) : option.speed;

        option.before();

        $('html, body')
            .stop()
            .animate({
                scrollTop:  option.why
            }, option.speed, option.easing, function(){

                option.after();

            });

    };

    $.fn.scrollTo = function(settings){

        var defaults = {
            speed: 'auto',
            easing: 'easeInOutExpo',
            why: false,
            before: function(){},
            after: function(){}
        };

        this.each(function(){

            var $this = $(this),
                href = $this.attr('href');

            var options = $.extend({}, defaults, settings, $this.data());

            $this.on('click', function(e){

                if( options.why === false && href ){

                    if( href == '#' ){

                        options.why = 0;

                    }else if( href.indexOf('#') != -1 ){

                        var $target = $(href);

                        if( $target.length > 0 ){

                            options.why = $target.offset().top;

                        }else{

                            options.why = 0;

                        }

                    }

                }

                if( e.which != 2 ){

                    $.scrollTo(options);

                    e.preventDefault();

                }

            });

        });

        return this;

    };

    $.fn.inAndOut = function(settings){

        var defaults = {
            speed: 300,
            delay: 0,
            middle: function(){}
        };

        this.each(function(){

            var o = $.extend(defaults, settings);

            var $this = $(this);

            $this
                .delay(o.delay)
                .transition({
                    opacity: 0,
                    x: 40,
                    scale: .9
                }, o.speed / 2, 'easeInCubic', function(){

                    o.middle();

                    $this
                        .css({
                            x: -40
                        })
                        .transition({
                            opacity: 1,
                            x: 0,
                            scale: 1
                        }, o.speed / 2, 'easeOutCubic');

                });

        });

        return this;

    };

    $.fn.slider = function(){

        var speed = 600;

        this.each(function(){

            if( !$(this).data('active') ){

                var $slider = {
                    root: $(this),
                    container: $(this).children('.container'),
                    nav: $('<nav/>'),
                    slides: $(this).find('.slide'),
                    arrows: $(this).children('.container').children('.arrow')
                };

                var slider = {
                    total: $slider.slides.length,
                    slide: $slider.slides,
                    current: 0,
                    busy: false
                };

                var goto = function(num, inFromRight){

                    slider.busy = true;

                    if( num > slider.total - 1 )
                        num = 0;

                    if( num < 0 )
                        num = slider.total - 1;

                    var $newSlide = $(slider.slide[num]),
                        $oldSlide = $(slider.slide[slider.current]);

                    $slider.container
                        .css({
                            height: $oldSlide.outerHeight(true)
                        });

                    $newSlide.css({
                        left: 0,
                        x:  inFromRight ? '100%' : '-100%',
                        perspective: 600,
                        rotateY: inFromRight ? -45 : 45,
                        opacity: 0
                    }).transition({
                        x:  '0%',
                        rotateY: 0,
                        opacity: 1
                    }, speed, 'easeInOutCubic', function(){

                        $newSlide.css({
                            position:   'relative'
                        });

                        $slider.container.removeAttr('style');

                        slider.busy = false;

                    });

                    if( num != slider.current ){

                        $oldSlide.transition({
                            position: 'absolute',
                            x: inFromRight ? '-100%' : '100%',
                            opacity: 0
                        }, speed, 'easeInOutCubic');

                    }

                    $slider.nav
                        .children('span:eq(' + num + ')')
                        .addClass('on')
                        .siblings('.on')
                        .removeClass('on');

                    slider.current = num;

                    setContainerHeight();

                };

                var setContainerHeight = function(noAnimation){

                    var height = $(slider.slide[slider.current]).outerHeight(true);

                    if( noAnimation ){

                        $slider.container
                            .css({
                                height: height
                            });

                    }else{

                        $slider.container
                            .transition({
                                height: height
                            }, 600, 'easeOutCubic');

                    }

                };

                $slider.nav.html(function(){

                    var html = '';

                    for( var i = 0; i < slider.total; i++ ){

                        html += '<span data-slide="' + i + '"' + ( i == slider.current ? 'class="on"' : '' ) + '><i></i></span>';

                    };

                    return html;

                }).appendTo($slider.root);

                $slider.arrows.on('click', function(e){

                    var $span = $(this),
                        next = $span.is('.next');

                    if( !slider.busy )
                        goto(next ? slider.current + 1 : slider.current - 1, next);

                    e.preventDefault();

                });

                $slider.nav.on('click', 'span', function(){

                    var newNum = $(this).data('slide');

                    if( !slider.busy )
                        goto(newNum, newNum > slider.current);

                });

                $slider.root.on({
                    unset:      function(){

                        $slider.container.removeAttr('style');
                        $slider.slides.removeAttr('style');
                        $slider.nav.remove();
                        $slider.arrows.off();
                        $slider.root.data('active', false);

                    }
                }).data('active', true);

            }

        });

        return this;

    };

    $.fn.inlineGallery = function(){

        this.each(function(){

            if( !$(this).data('active') ){

                var $gallery = {
                    root: $(this),
                    nav: $('<nav/>')
                };

                var gallery = {
                    folder: $gallery.root.data('folder'),
                    image: $gallery.root.data('files').split(', '),
                    current: 0,
                    busy: false
                };

                gallery['total'] = gallery.image.length;

                var goto = function(num){

                    gallery.busy = true;

                    if( num > gallery.total - 1 )
                        num = 0;

                    if( num < 0 )
                        num = gallery.total - 1;

                    var $newImg = $(gallery.image[num]),
                        $oldImg = $(gallery.image[gallery.current]);

                    $newImg.css({
                        position: 'relative',
                        opacity: 1,
                        zIndex: 0
                    });

                    $oldImg.css({
                        position: 'absolute',
                        zIndex: 10
                    }).transition({
                        opacity: 0
                    }, 400, 'smoothFade', function(){

                        gallery.busy = false;

                    });

                    $gallery.nav
                        .children('span:eq(' + num + ')')
                        .addClass('on')
                        .siblings('.on')
                        .removeClass('on');

                    gallery.current = num;

                };

                $gallery.root.on({
                    unset: function(){

                        $gallery.images.removeAttr('style');
                        $gallery.nav.remove();
                        $gallery.root.data('active', false);

                    }
                });

                $gallery.nav.on('click', 'span:not(.on)', function(){

                    if( !gallery.busy )
                        goto($(this).data('show'));

                });

                $gallery.root.html(function(){

                    var html = '<div class="images">';

                    for (var i = 0; i < gallery.image.length; i++) {

                        html += '<img src="' + gallery.folder + '/' + gallery.image[i] + '" alt="Image">';

                    };

                    return html + '</div>';

                }).data('active', true);

                $gallery.nav.html(function(){

                    var html = '';

                    for (var i = 0; i < gallery.image.length; i++) {

                        html += '<span data-show="' + i + '"' + ( i == gallery.current ? ' class="on"' : '' ) + '><img src="' + gallery.folder + '/' + gallery.image[i] + '" alt="Image thumbnail"></span>';

                    };

                    return html;

                }).appendTo($gallery.root);

                $gallery['images'] = $gallery.root.children('.images');

                gallery.image = $gallery.images.children('img');

                $(gallery.image[gallery.current]).css({
                    opacity: 1,
                    position: 'relative'
                });

            }

        });

        return this;

    };

    $.fn.loadImages = function(){

        this.each(function(){

            var $this = $(this),
                data = $this.data(),
                src = data.img;

            if( data.insert ){

                var $img = $('<img/>');

                $img.preload({
                    src: src,
                    ready: function(){

                        if( data.replace ){

                            $this.empty();

                        }

                        $this.append($img);

                        if( data.fade ){

                            $img.css({
                                opacity: 0
                            }).transition({
                                opacity: 1
                            }, 1000, 'smoothFade', function(){

                                $img.removeAttr('style');
                                $this.removeAttr('style')

                            });

                        }

                    }
                });

            }else{

                $this.css({
                    opacity: data.fade ? 0 : 1,
                    backgroundImage: 'url(' + src + ')'
                });

                if( data.fade ){

                    $this.transition({
                        opacity: 1
                    }, 1000, 'smoothFade');

                }

            }

        });

        return this;

    };

    $.fn.preload = function(settings){

        var defaults = {
            src: null,
            timeout: 2000,
            ready: function(){},
            error: function(){}
        };

        this.each(function(){

            var option = $.extend(defaults, settings);

            var tooSlow = false,
                complete = false;

            option.src = option.src.replace(' ', '%20');

            if( option.src ){

                $(this).one('load', function(){

                    var img = this;

                    // Timeout for Webkit
                    // As the width/height of the image is 0 initially
                    setTimeout(function(){

                        complete = true;

                        if( !tooSlow )
                            option.ready();

                    }, 0);

                })
                .one('error', function(){

                    option.error();

                })
                .attr('src', option.src)
                .each(function() {

                    if( this.complete ){

                        $(this).trigger('load');

                    }

                });

                if( option.timeout ){

                    setTimeout(function(){

                        tooSlow = true;

                        if( !complete )
                            option.ready();

                    }, option.imageTimeout);

                }

            }

        });

        return this;

    };

    $.fn.simpleSelect = function(settings) {

        // Settings
        var defaults = {
            defaultText: null,
            ready: function(){},
            click: function(){},
            change: function(){}
        };

        var o = $.extend(defaults, settings);

        return this.each(function(){

            // Objects
            var $this = $(this);

            if( !$this.data('active') ){

                // Are there classes
                var classes = 'select ' + ($this.attr('class') ?
                        $this.attr('class') : ''),
                    // Set the initial text
                    initial = o.defaultText === null
                        ? $this.find('option:selected').text()
                        : o.defaultText,
                    // The new select
                    $s;

                // Wrap everything up
                $this
                    .wrap('<span class="' + classes + '"/>');

                $s = $this
                    .parent('.select');

                // Add in the other contnent
                $s
                    .prepend('<span>' + initial + '</span>');

                $this.data('active', true);

                // Sort out the original select
                $this
                    .css({
                        width: $s.innerWidth(),
                        height: $s.innerHeight(),
                        opacity: 0
                    }).on({
                        change: function(){

                            $s.find('span')
                                .text( $this.find('option:selected').text() );

                            o.change.apply($this);

                        },
                        click: function(){

                            o.click.apply($this);

                        },
                        focus: function(){

                            $s.addClass('focus');

                        },
                        blur: function(){

                            $s.removeClass('focus');

                        },
                        mouseenter: function(){

                            $s.addClass('hover');

                        },
                        mouseleave: function(){

                            $s.removeClass('hover');

                        }

                    });

                o.ready.apply($this);

            }

        });

    };

    $.fn.openAfterRow = function(settings){

        var defaults = {
            items: 'children',
            trigger: '.button-extra-small',
            template: 'template',
            beforeInsert: function(){},
            onClose: function(){}
        };

        var getPositionData = function(items){

            var positions = [];

            for( var i = 0; i < items.length; i++ ){

                positions[i] = $(items[i]).position().top;

            };

            return positions;

        };

        var getInsertPosition = function(id, oar){

            for( var i = id; i < oar.length; i++ ){

                if( oar[ i + 1 ] == undefined ){

                    return i;

                    break;

                }

                if( oar[id] < oar[i] ){

                    return i - 1;

                    break;

                }

            };

        };

        this.each(function(){

            var option = $.extend(defaults, settings);

            var $oar = $(this);

            $oar = {
                root: $oar,
                template: $('#' + $oar.data(option.template)).remove().clone().removeAttr('id'),
                items: option.items == 'children' ? $oar.children() : $oar.find(option.items),
                current: false
            };

            var oar = {
                item: $oar.items,
                content: [],
                position: getPositionData($oar.items),
                open: false,
                resize: false,
                busy: false
            };

            $oar.items.each(function(i){

                var $item = $(this);

                $item
                    .find(option.trigger)
                    .data('id', i);

            });

            var removeContent = function(forcedClose){

                if( forcedClose ){

                    option.onClose($(oar.item[oar.open]));
                    oar.open = false;

                }

                $oar.current.remove();

                $oar.current = false;

            };

            var closeContent = function(callback){

                option.onClose($(oar.item[oar.open]));

                $oar.current
                    .css({
                        height: $oar.current.height()
                    })
                    .transition({
                        height: 0
                    }, 300, 'easeInOutCubic', function(){

                        removeContent();

                        if( callback )
                            callback.apply();

                    });

            };

            var insertContent = function($this, id){

                oar.busy = true;

                var $thisItem = $(oar.item[id]),
                    $endItem = $(oar.item[ getInsertPosition(id, oar.position) ])

                $oar.current = $oar.template
                    .clone()
                    .insertAfter( $endItem );

                option.beforeInsert($oar.current, $thisItem, $this, id);

                var height = $oar.current.height();

                $oar.current
                    .css({
                        height: 0
                    })
                    .transition({
                        height: height
                    }, 300, 'easeInOutCubic', function(){

                        $oar.current
                            .removeAttr('style');

                        oar.open = id;

                        oar.busy = false;

                    });

            };

            $core.win
                .on('resize.oar', function(){

                    if( !oar.resize ){

                        if( $oar.current )
                            removeContent(true);

                    }

                    clearTimeout(oar.resize);

                    oar.resize = setTimeout(function(){

                        oar.resize = false;

                        oar.position = getPositionData($oar.items);

                    }, 100);

                });

            $oar.root
                .on('click', option.trigger, function(e){

                    if( !oar.busy ){

                        var $this = $(this),
                            id = $this.data('id');

                        if( oar.open !== false ){

                            closeContent(function(){

                                if( oar.open != id ){

                                    insertContent($this, id);

                                }else{

                                    oar.open = false;

                                }

                            });

                        }else{

                            insertContent($this, id);

                        }

                    }

                });

        });

        return this;

    };

})(jQuery);


//
//  Popup content
//

(function($){
    var methods = {
        init: function(options) {

            var $links = $(this);

            $links
                .each(function(){

                    var id = $(this).data('popup'),
                        $popup = $('#' + id);

                    if( !$c[id] ) {

                        $c[id] = {
                            root: $popup,
                            container: $popup.children(),
                            content: $popup.find('.content'),
                            heading: $popup.find('h3:first')
                        };

                        $('<span class="close">&times;</span>')
                            .appendTo($c[id].heading)
                            .on('click', function(e){

                                if( !c.busy ){

                                    $.popupContent('hide');

                                    e.preventDefault();

                                }

                            });

                    }

                });

            $links
                .on('click', function(e) {
                    e.preventDefault();

                    const popup = $(this).data('popup');

                    $.popupContent('show', popup);

                    if (popup === 'purchase-enquiry') {
                        const interested = {
                            field: $c[popup].root.find('[name="car_interested_in"]'),
                            value: $(this).data('interested-in')
                        }

                        if (interested.field.length && interested.value.length) {
                            interested.field.val(interested.value);
                        }
                    }
                });

            return this;

        },
        show: function(id) {

            var rePosition = false;

            c.open = id;

            c.busy = true;

            //  Prevent body scrolling (MAGICS!)
            $core.body.css({
                overflow: 'hidden'
            });

            $c[id].root
                .css({
                    display: 'block',
                    opacity: 0
                })
                .transition({
                    opacity: 1
                }, 300, 'smoothFade');

            $.popupContent('position');

            $core.win.on('resize.popup-content', function(e){

                if( !c.resize ){

                    if( $core.win.width() != site.size.x ){

                        rePosition = true;

                        $c[id].container
                            .css({
                                opacity: 0
                            });

                    }

                }

                clearTimeout(c.resize);

                c.resize = setTimeout(function(){

                    c.resize = false;

                    if( rePosition )
                        $.popupContent('position');

                }, 100);

            });

            $core.doc.on('keydown.popup-content', function(e){

                if( e.keyCode == 27 && !c.busy ){

                    $.popupContent('hide');

                    e.preventDefault();

                }

            });

            $('select').simpleSelect();

        },
        position: function() {

            $c[c.open].container
                .removeAttr('style')
                .css({
                    display: 'block',
                    opacity: 0,
                    scale: .8
                });

            $c[c.open].content
                .removeAttr('style');

            var containerHeight = $c[c.open].container.height(),
                containerWidth = $c[c.open].container.width(),
                contentHeight = $c[c.open].content.innerHeight(),
                headingHeight = $c[c.open].heading.innerHeight();

            $c[c.open].content
                .css({
                    height: containerHeight - headingHeight
                });

            $c[c.open].container
                .css({
                    top: '50%',
                    marginTop: 0 - Math.round( containerHeight / 2 ),
                    marginLeft: 0 - Math.round( containerWidth / 2 )

                })
                .transition({
                    scale: 1,
                    opacity: 1
                }, 300, 'easeOutCubic', function(){

                    c.busy = false;

                });

        },
        hide: function() {

            c.busy = true;

            $c[c.open].root
                .transition({
                    opacity: 0
                }, 300, 'smoothFade', function(){

                    $(this).hide();

                });

            $c[c.open].container
                .transition({
                    scale: .8,
                    opacity: 0
                }, 300, 'smoothFade', function(){

                    c.busy = false;

                });

            $core.body.css({
                overflow: 'auto'
            });

            //  Remove tempoary events
            $core.doc.off('keydown.popup-content');
            $core.win.off('resize.popup-content');

            c.open = false;

        }
    };

    var $c = {};

    var c = {
        busy: false,
        resize: false,
        open: false
    };

    $.popupContent = function(methodOrOptions){

        if( methods[methodOrOptions] ){

            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));

        }else if( typeof methodOrOptions === 'object' || !methodOrOptions ){

            // Default to "init"
            return methods.init.apply( this, arguments );

        } else {

            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.popupGallery' );

        }

        return this;

    };

    $.fn.popupContent = function(methodOrOptions){

        if( methods[methodOrOptions] ){

            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));

        }else if( typeof methodOrOptions === 'object' || !methodOrOptions ){

            // Default to "init"
            return methods.init.apply( this, arguments );

        } else {

            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.popupGallery' );

        }

        return this;

    };

})(jQuery);


//
//  Popup image gallery
//

(function($){

    var $g = $('#popup-gallery');

    $g = {
        root: $g,
        image: {
            root: $g.find('.image'),
            container: $g.children('.image-container')
        },
        close: $g.find('.close'),
        loading: $g.children('.loading'),
        arrows: $g.children('span[class^="arrow-"]')
    }

    var g = {
        busy: false,
        resize: false,
        open: false,
        current: 0,
        set: []
    };

    var getMargin = function($this){

        return ( 0 - ( $this.height() / 2 ) ) + 'px 0 0 ' + ( 0 - ( $this.width() / 2 ) ) + 'px';

    };

    var buildSet = function(data){

        var images = data.files.split(',');

        var set = {
            path: data.folder,
            image: images,
            current: data.keyimage ? data.keyimage : 0,
            total: images.length
        };

        return set;

    };

    var insertNewImage = function(){

        $g.image.container
            .css({
                top: 0,
                left: 0
            });

        var image = g.set[g.current].image[g.set[g.current].current];

        var $img = $('<img src="' + g.set[g.current].path + image + '" alt="Gallery image">').preload({
            timeout: false,
            ready: function(){

                //  Insert the photo
                $g.image.root
                    .empty()
                    .append( $img );

                $g.image.container
                    .css({
                        top: '45%',
                        left: '50%',
                        scale: .8,
                        margin: getMargin($g.image.root)
                    })
                    .transition({
                        opacity: 1,
                        scale: 1
                    }, 300, 'easeOutCubic', function(){

                        g.busy = false;

                    });

            },
            src: g.set[g.current].path + image
        });

    }

    var methods = {
        init: function(options) {

            var $this = $(this),
                data = $this.data(),
                id = g.current;

            g.set[ g.current ] = buildSet( data );

            $this.on('click', data.triggers, function(e){

                $this.popupGallery('show', {
                    id: id,
                    ready: function(){

                        $.popupGallery('goto');

                    }
                });

                e.preventDefault();

            });

            g.current++;

        },
        show: function(options) {

            $g.root
                .css({
                    display: 'block',
                    opacity: 0
                })
                .transition({
                    opacity: 1
                }, 300, 'smoothFade');

            g.current = options.id;

            $core.doc.on('keydown.popup-gallery', function(e){

                if( ( e.keyCode == 37 || e.keyCode == 39 ) && !g.busy ){

                    $.popupGallery('goto', e.keyCode == 37 ? 'prev' : 'next');

                    e.preventDefault();

                }

                if( e.keyCode == 27 && !g.busy ){

                    $.popupGallery('hide');

                    e.preventDefault();

                }

            });

            $core.win.on('resize.popup-gallery', function(){

                if( !g.resize ){

                    $g.image.container
                        .css({
                            opacity: 0
                        });

                }

                clearTimeout(g.resize);

                g.resize = setTimeout(function(){

                    g.resize = false;

                    $g.image.container
                        .css({
                            top: 0,
                            left: 0
                        });

                    $g.image.container
                        .css({
                            top: '50%',
                            left: '50%',
                            margin: getMargin( $g.image.root )
                        })
                        .transition({
                            opacity: 1
                        }, 400, 'smoothFade');

                }, 100);

            });

            options.ready.apply();

        },
        hide: function() {

            $g.image.container
                .transition({
                    scale: .8
                });

            $g.root.transition({
                opacity: 0
            }, 300, 'smoothFade', function(){

                $g.root.css({
                    display: 'none'
                });

                $g.image.root.empty();

            });

            g.open = false;

            $core.doc.off('keydown.popup-gallery');
            $core.win.off('resize.popup-gallery');

        },
        goto: function(action) {

            if( !g.busy ){

                g.busy = true;

                if( typeof action == 'string' ){

                    g.set[g.current].current = action == 'prev' ? g.set[g.current].current - 1 : g.set[g.current].current + 1;

                    if( g.set[g.current].current > g.set[g.current].total - 1 )
                        g.set[g.current].current = 0;

                    if( g.set[g.current].current < 0 )
                        g.set[g.current].current = g.set[g.current].total - 1;

                }else{

                    g.set[g.current].current = action ? action : g.set[g.current].current;

                }

                if( g.open ){

                    $g.image.container.transition({
                        scale:      .8,
                        opacity:    0
                    }, 300, 'easeOutCubic', function(){

                        insertNewImage();

                    });

                }else{

                    g.open = true;

                    insertNewImage();

                }

            }

        }
    };

    $g.arrows.on('click', function(e){

        $.popupGallery('goto', $(this).is('.arrow-left') ? 'prev' : 'next');

        e.preventDefault();

    });

    $g.close.on('click', function(e){

        $.popupGallery('hide');

        e.preventDefault();

    });

    $.popupGallery = function(methodOrOptions){

        if( methods[methodOrOptions] ){

            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));

        } else {

            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.popupGallery' );

        }

    };

    $.fn.popupGallery = function(methodOrOptions){

        if( methods[methodOrOptions] ){

            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));

        }else if( typeof methodOrOptions === 'object' || ! methodOrOptions ){

            // Default to "init"
            this.each(function(){

                return methods.init.apply( this, arguments );

            });

        } else {

            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.popupGallery' );

        }

        return this;

    };

})(jQuery);

// $.cssEase['smoothFade'] = 'cubic-bezier(.365,.005,.355,1)';


//
//  ANIMATION EASING
//

jQuery.extend( jQuery.easing,
{
    def: 'OutQuad',
    swing: function (x, t, b, c, d) {
        //alert(jQuery.easing.default);
        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
    },
    easeInQuad: function (x, t, b, c, d) {
        return c*(t/=d)*t + b;
    },
    easeOutQuad: function (x, t, b, c, d) {
        return -c *(t/=d)*(t-2) + b;
    },
    easeInOutQuad: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t + b;
        return -c/2 * ((--t)*(t-2) - 1) + b;
    },
    easeInCubic: function (x, t, b, c, d) {
        return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;
        return c/2*((t-=2)*t*t + 2) + b;
    },
    easeInQuart: function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t + b;
    },
    easeOutQuart: function (x, t, b, c, d) {
        return -c * ((t=t/d-1)*t*t*t - 1) + b;
    },
    easeInOutQuart: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
        return -c/2 * ((t-=2)*t*t*t - 2) + b;
    },
    easeInQuint: function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
        return c/2*((t-=2)*t*t*t*t + 2) + b;
    },
    easeInSine: function (x, t, b, c, d) {
        return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
    },
    easeOutSine: function (x, t, b, c, d) {
        return c * Math.sin(t/d * (Math.PI/2)) + b;
    },
    easeInOutSine: function (x, t, b, c, d) {
        return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
    },
    easeInExpo: function (x, t, b, c, d) {
        return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
    },
    easeOutExpo: function (x, t, b, c, d) {
        return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
        if (t==0) return b;
        if (t==d) return b+c;
        if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    easeInCirc: function (x, t, b, c, d) {
        return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
    },
    easeOutCirc: function (x, t, b, c, d) {
        return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
    },
    easeInOutCirc: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
        return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
    },
    easeInElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
    },
    easeOutElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
    },
    easeInOutElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
        return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
    },
    easeInBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c*(t/=d)*t*((s+1)*t - s) + b;
    },
    easeOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
    },
    easeInOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
        return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
    },
    easeInBounce: function (x, t, b, c, d) {
        return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
    },
    easeOutBounce: function (x, t, b, c, d) {
        if ((t/=d) < (1/2.75)) {
            return c*(7.5625*t*t) + b;
        } else if (t < (2/2.75)) {
            return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
        } else if (t < (2.5/2.75)) {
            return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
        } else {
            return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
        }
    },
    easeInOutBounce: function (x, t, b, c, d) {
        if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
        return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
    },
    smoothFade: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;
        return c/2*((t-=2)*t*t + 2) + b;
    }
});


//
//  EXTERNAL LINKS
//

jQuery.extend( jQuery.expr[':'],{
    external: function(obj, index, meta, stack){

        return /:\/\//.test($(obj).attr('href'));

    },
    internal: function(obj, index, meta, stack){

        return !/:\/\//.test($(obj).attr('href'));

    }
});


//
//  Modernizer
//

var mod = 'modernizr';

function injectElementWithStyles( rule, callback, nodes, testnames ){

    var style, ret, node, docOverflow,
        div = document.createElement('div'),
        body = document.body,
        fakeBody = body || document.createElement('body');

    if( parseInt(nodes, 10) ){

        while( nodes-- ){

            node = document.createElement('div');
            node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
            div.appendChild(node);

        }

    }

    style = ['&#173;','<style id="s', mod, '">', rule, '</style>'].join('');

    div.id = mod;

    (body ? div : fakeBody).innerHTML += style;

    fakeBody.appendChild(div);

    if( !body ){

        fakeBody.style.background = '';
        fakeBody.style.overflow = 'hidden';
        docOverflow = docElement.style.overflow;
        docElement.style.overflow = 'hidden';
        docElement.appendChild(fakeBody);

    }

    ret = callback(div, rule);

    if( !body ){

        fakeBody.parentNode.removeChild(fakeBody);
        docElement.style.overflow = docOverflow;

    }else{

        div.parentNode.removeChild(div);

    }

    return !!ret;

}

function detectTouch() {

    var bool,
        prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

    if( ( 'ontouchstart' in window ) || window.DocumentTouch && document instanceof DocumentTouch ){

        bool = true;

    }else{

        injectElementWithStyles( ['@media (', prefixes.join('touch-enabled),('), mod, ')', '{#modernizr{top:9px;position:absolute}}'].join(''), function( node ){

            bool = node.offsetTop === 9;

        });

    }

    return bool;

};
